export default __webpack_public_path__ + "static/media/Quartermaster's Remedial Band.b726f0d3.jpg";